import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BasicTextArea, BaasicButton } from 'core/components';

function FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModalTemplate({ facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModalStore, t }) {
    const {
        form,
        modalParams
    } = facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModalStore;

    const onKeyDown = (e) => {
        if (e.keyCode == 13) {
            e.preventDefault();
            form.onSubmit(e);
        }
    }

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Eligibility Status Note</h3>
            </div>
            <div className="modal__body">
                <div className="form__group">
                    <BasicTextArea field={form.$('eligibilityStatusNote')} onKeyDown={onKeyDown} isFocus={true} />
                </div>
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
                <BaasicFormControls
                    form={form}
                    className='btn btn--med btn--primary'
                    onSubmit={form.onSubmit}
                    disabled={form.submitting || form.validating}
                    label={t('EDIT_FORM_LAYOUT.SAVE')}
                />
            </div>
        </section>
    )
}

FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModalTemplate.propTypes = {
    facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModalTemplate);
